import React from "react"
import Embed from "react-tiny-oembed"

import RichText from "../richText/Parser"
import { DownloadDocument } from "./DownloadDocument"

const renderSwitch = (component, post) => {
  switch (component.fieldGroupName) {
    case "Post_Postcontent_Components_RichContent":
      if (!component.richContent) return null
      return (
        <RichText option="postOptions" stringHtml={component.richContent} />
      )
    case "Post_Postcontent_Components_Oembed":
      return (
        <div className="rounded-lg overflow-hidden">
          <Embed url={component.url} />
        </div>
      )
    case "Post_Postcontent_Components_Downloaddocument":
      return <DownloadDocument post={post} component={component} />
    default:
      return <br />
  }
}

export function PostContent({ post, content }) {
  const components = content?.components
  return (
    <div className="mt-6 prose prose-lg text-gray-500 prose-scooter max-w-prose-articles">
      {components &&
        components.map((component, key) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={key}>{renderSwitch(component, post)}</div>
        ))}
    </div>
  )
}
